import { whistleBlowing } from '../../utils/types'
import { BASE_URL } from '../endpoints'
import { del, get, patch, post } from '../https'

export const getWhistleBlowing = (
  // page: number,
  sortBy: string,
  sortOrderValue: string
): Promise<unknown> => {
  return get(
    `${BASE_URL}/whistle-blowings/?sortBy=${sortBy}&sortOrder=${sortOrderValue}`
  )
}

export const getWhistleBlowingRouting = (): Promise<unknown> => {
  return get(`${BASE_URL}/whistle-blowings/routing`)
}

export const createWhistleBlowing = (
  data: whistleBlowing
): Promise<unknown> => {
  return post(`${BASE_URL}/whistle-blowings`, data, null)
}

export const updateWhistleBlowingStatus = (
  data: {
    status: string
  },
  id: string
): Promise<unknown> => {
  return patch(`${BASE_URL}/whistle-blowings/${id}/change-status`, data, null)
}

export const deleteWhistleBlowing = ({
  id,
}: {
  id: string | undefined
}): Promise<unknown> => {
  return del(`${BASE_URL}/whistle-blowings/${id}`, null)
}

export const getSingleWistleBlowingById = (
  id: string,
  sId: string
): Promise<unknown> => {
  return get(`${BASE_URL}/whistle-blowings/${id}?school=${sId}`)
}
export const getWistleBlowingComments = (id: string): Promise<unknown> => {
  return get(`${BASE_URL}/whistle-blowings/${id}/comments`)
}
export const addWistleBlowingComments = (
  data: {
    comment: string
  },
  id: string
): Promise<unknown> => {
  return post(`${BASE_URL}/whistle-blowings/${id}/comments`, data, null)
}

//invite

export const getAllWhistleInvitedUsers = (id: string): Promise<unknown> => {
  return get(`${BASE_URL}/whistle-blowings/${id}/invitations`)
}

export const createWhistleInvitation = (
  data: {
    userId: string
    viewAccess: boolean
    editAccess: boolean
    deleteAccess: boolean
  },
  id: string
): Promise<unknown> => {
  return post(`${BASE_URL}/whistle-blowings/${id}/invitations`, data, null)
}

export const deleteWhistleInvitation = ({
  id,
}: {
  id: string | undefined
}): Promise<unknown> => {
  return del(`${BASE_URL}/whistle-blowings/invitations/${id}`, null)
}
